import img from "../../../src/pages/manage-project-dependencies-with-simple-installer/simple-installer.gif";
import { graphql } from "gatsby";
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default {
  img,
  graphql,
  React,
  MDXTag
};